const LoginAPI = {
  //API_ROOT_URL: "/security-center",
  API_ROOT_URL: "", //In ENV already
  // API_ROOT_URL: "permission",
};
export default LoginAPI;
